import {
  BetweenItemDropBorder,
  type BetweenItemDropBorderProps,
} from 'components/BetweenItemDropBorder';
import {
  CUSTOM_DRAGGABLE_ITEM_TYPES,
  DROP_RESULT_TYPES,
  useDrop,
} from 'components/customDragLayer';

type BetweenOrderItemDropBorderProps = Pick<
  BetweenItemDropBorderProps,
  'side'
> & {
  index: number;
};

const DROP_AREA_HEIGHT = 5;

export const BetweenOrderItemDropBorder = ({
  index,
  side,
}: BetweenOrderItemDropBorderProps) => {
  const [{ isOver, canDrop }, connectDropTarget] = useDrop({
    accept: CUSTOM_DRAGGABLE_ITEM_TYPES.ORDER_REVIEW_ITEM,
    collect: (monitor) => ({
      isOver: monitor.isOver({ shallow: true }),
      canDrop: monitor.canDrop(),
    }),
    onDropEnd: () => ({
      dropResultType: DROP_RESULT_TYPES.REORDER_ORDER_REVIEW_ITEMS,
      newIndex: index,
    }),
  });

  return (
    <BetweenItemDropBorder
      ref={connectDropTarget}
      side={side}
      canDrop={canDrop}
      isOver={isOver}
      dropAreaProps={{ h: DROP_AREA_HEIGHT }}
    />
  );
};
